import { render, staticRenderFns } from "./ChangeStatuses.vue?vue&type=template&id=3a63b5b6&scoped=true"
import script from "./ChangeStatuses.vue?vue&type=script&lang=js"
export * from "./ChangeStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a63b5b6",
  null
  
)

export default component.exports